module.exports = ['$scope', '$rootScope', 'OrderRequestSvc', 'MembershipSvc', function ($scope, $rootScope, OrderRequestSvc, MembershipSvc) {
    'use strict';

    // ------------------
    // Scope functions
    // ------------------


    // ------------------
    // Load Dependent Data
    // ------------------
    function fetchData() {
        OrderRequestSvc.list($scope.plant).then(function (result) {
            $scope.order_requests = result.data;
        });

        if ($scope.permissions.edit_users) {
            MembershipSvc.count_by_role($rootScope.plant, "Customer").success(function (count) {
                $scope.customer_count = count;
            });
        }
    }

    // ------------------
    // EVENTS
    // ------------------
    $scope.$on('refresh-signal', function () {
        fetchData();
    });

    // ------------------
    // Initialization
    // ------------------
    $scope.order_requests = [];
    $scope.customer_count = 0;

    fetchData();

}];

